// 登录态 token 读取与过期判定(学生端/教师端路由守卫共用, 2026-10-30)
// 背景: 两端守卫原只查 zhimingUserTokenData 键存在即放行, token 过期(24h)后学生一路
// 可浏览做题, 直到手写 OSS 签发(/console/oss_sign_dots_write)等严格验签接口才 401,
// 已写作答体验上白写——守卫层前置拦截: 过期即提示"登录已过期"并跳登录页。
// 本模块同时收敛 handwrite-dots-store 的 _userToken 同源逻辑(单一来源)。

// 读取本地登录 token, 返回裸 JWT 串; 无/提取不到返回 ''
// 兼容两种存量形态: 学生端=JSON字符串包裸token('"eyJ.."'), 教师端=JSON对象(token在.token字段)。
// 不走 JSON.parse(坏 JSON 必抛需 catch 兜底): JWT 三段 base64url 的 header 恒以 eyJ 开头
// ({"alg":..} 的 base64), 正则直接从原始串提取, 两种形态一次覆盖, 零异常路径
export function getStoredUserToken() {
    var raw = localStorage.getItem('zhimingUserTokenData') || ''
    var m = raw.match(/eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/)
    return m ? m[0] : ''
}

// 判 token 是否过期: true=过期/无效(缺失、非三段、payload 无 exp), false=有效。
// 无效一律按过期拦截(fail-fast 显式引导重新登录, 不静默放行)
export function isTokenExpired(token) {
    if (!token) return true
    var parts = token.split('.')
    if (parts.length !== 3) return true
    var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    while (b64.length % 4) b64 += '='
    // payload 为 jsonwebtoken 紧凑 JSON 产物, exp 键格式固定, 正则提取免整包 parse
    var m = window.atob(b64).match(/"exp"\s*:\s*(\d+)/)
    if (!m) return true
    return parseInt(m[1], 10) * 1000 <= Date.now()
}
